import React, { useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import { Datagrid, Icon, Button, Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import "./energy-data-comp.css";
import PeriodList from '../../Period-Dropdown-list/period-dropdown-list';
import dataGrid from './energy-data-comp.json';
import { BASE_URL } from '../../../strings';
import { getToken } from '../../Authentication/get-token';

import "./energy-data-comp.css"
const EngergyDataCmp = () => {
  const [energyComparisonData, setEnergyComparisonData] = useState([]);
    const [monochrome, setMonochrome] = useState(false);
    const [columns, setColumns] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}emapi/energy_data_comp`,getToken())
      .then((response) => {
        const formattedData = response.data?.data || [];
        console.log("formattedData",formattedData)
        setEnergyComparisonData(formattedData);
         setColumns([
                    { fieldKey: 'group', title: 'Group' },
                    { fieldKey: 'active_energy', title: 'Current Cost' },
                    { fieldKey: 'prev_active_energy', title: 'Previous Cost' }
                ]);
      })
      .catch((error) => {
        console.error("Error fetching energy comparison data:", error);
      });
  }, []);

   const data = useMemo(() => {
         return energyComparisonData.map((item, i) => ({
             rowId: `row-${i}`,
             fields: {
                 group: item.group,
                 active_energy: item.active_energy,
                 prev_active_energy: item.prev_active_energy,
                
             }
         }));
     }, [energyComparisonData]);

    return (
        <div>
            <div className='indicator-container-line'>
                <PeriodList />
                {dataGrid.dropdowns.map((dropdown, index) => (
                    <Dropdown style={{ visibility: "hidden" }} key={index} label={dropdown.label} placeholder={dropdown.placeholder} monochrome={monochrome}>
                        {dropdown.options.map(option => (
                            <DropdownOption key={option.key} label={option.label} value={option.value} />
                        ))}
                    </Dropdown>
                ))}
            </div>

             <Datagrid
              id='energy-data-compare'
          data={data}
           style={{ height: '240px', width: "90%" }}
          columns={columns}
          rowHeight="small"
          enableSorting
        />
        </div>
    );
};

export default EngergyDataCmp;
